<template>
  <div class="main-page">
    <!-- 原有内容保持不变 -->
    <div class="content-section">
      <div class="left-section">
        <div class="header-section">
          <div class="header-content">
            <img src="@/assets/owl_1.svg" alt="Owl Icon" class="h3-svg-icon">
            <h3>猫头鹰AI视光师助理</h3>
          </div>
        </div>
        <div class="chart-main"><EyeChart @on-row-click="handleRowClick" @ai-analysis-result="handleAIAnalysisResult" ref="eyeChart"/></div>
      </div>
      <div class="right-section">
        <!-- 登出按钮和欢迎信息移到这里 -->
        <div class="logout-btn-container">
          <span class="welcome-text" v-if="userInfo.store && userInfo.optometrist">
            欢迎您，{{ userInfo.store }}，{{ userInfo.optometrist }}
          </span>
          <el-button round type="danger" size="mini" icon="el-icon-switch-button" style="font-size: 14px;" @click="goToLogin">
            退出登录
          </el-button>
        </div>
        <div class="canvas-aside"><EyeKonva ref="eyeCanvas"/></div>
      </div>
    </div>
    
    <!-- AI分析区域 -->
    <div class="ai-main" id="printArea"><EyeAI :value="aiAnalysisResult"/></div>
  </div>
</template>

<script>
import EyeChart from './EyeChart.vue'
import EyeKonva from './EyeKonva.vue'
import EyeAI from './EyeAI.vue';

export default {
  name: 'MainPage',
  components: {
    EyeChart,
    EyeKonva,
    EyeAI
  },
  data() {
    return {
      aiAnalysisResult: '<div style="text-align: center;"><h2>点击"AI分析"查看AI分析结果</h2></div>',
      userInfo: {
        store: '',
        optometrist: ''
      }
    }
  },
  mounted() {
    // 从本地存储获取用户信息
    const savedUserInfo = localStorage.getItem('userInfo');
    if (savedUserInfo) {
      this.userInfo = JSON.parse(savedUserInfo);
    }
    
    // 从后端获取最新的用户信息并更新本地存储
    this.fetchUserInfo();
  },
  methods: {
    handleRowClick(scores) {
      console.log('Row clicked with scores:', scores);
      if (this.$refs.eyeCanvas) {
        this.$refs.eyeCanvas.drawNode(scores);
      } else {
        console.error('MainPage: eyeCanvas ref not found');
      }
    },
    handleAIAnalysisResult(result) {
      console.log('AI analysis result received:', result);
      this.aiAnalysisResult = result;
    },
    // 新增登出方法
    goToLogin() {
      // 清除本地存储的用户信息
      localStorage.removeItem('userInfo');
      window.location.replace('/login')
    },
    // 从后端获取用户信息
    fetchUserInfo() {
      this.$http.get('/api/user_info/', { withCredentials: true })
        .then(response => {
          if (response.data.status === 'ok') {
            const userInfo = {
              store: response.data.store,
              optometrist: response.data.optometrist
            };
            this.userInfo = userInfo;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
          }
        })
        .catch(error => {
          console.error('获取用户信息失败:', error);
          // 如果获取失败，可能是未登录，跳转到登录页
          if (error.response && error.response.status === 401) {
            this.$router.push('/login');
          }
        });
    }
  }
}
</script>

<style scoped>
  /* 原有样式保持不变 */
  .main-page {
    display: flex;
    flex-direction: column;
  }

  /* 修改登出按钮和欢迎信息样式 */
  .logout-btn-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 15px;
    padding: 0 0 10px 0;
  }

  .welcome-text {
    color: #0369a1;
    font-size: 14px;
    font-weight: 500;
  }

  /* 原有样式保持不变 */
  .content-section {
    display: flex;
    align-items: flex-start;
    flex-shrink: 0;
    max-height: 480px;
    gap: 20px;
    overflow: visible;
    padding: 10px 20px 0 20px;
  }

  .left-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  /* 新增右侧区域样式 */
  .right-section {
    flex: 0 0 502px;
    width: 502px;
    display: flex;
    flex-direction: column;
  }

  .header-section {
    height: 80px;
    flex-shrink: 0;
  }

  .header-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 10px;
  }

  .h3-svg-icon {
    height: 70px;
    width: auto;
  }

  .header-content h3 {
    font-size: 36px;
    margin: 14px;
    display: inline-block;
  }

  .chart-main {
    flex: 1;
    min-height: 0;
    overflow: visible;
  }

  .chart-main ::v-deep .el-table {
    max-width: 100%;
  }

  .canvas-aside {
    flex: 1;
  }

  .ai-main {
    flex: 1;
    min-height: 200px;
    padding: 20px;
    overflow: hidden;
  }
</style>
